// extracted by mini-css-extract-plugin
module.exports = {"lia-navbar-dropdown-anchor":"NavbarDropdownToggle_lia-navbar-dropdown-anchor__Z5meP","lia-link-extender":"NavbarDropdownToggle_lia-link-extender__HG9yN"};